export class AppConstants {
	public static sectionEmpty = [];
	public static sectionExploration = [
		{
			//1
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					title: "1920<span class=\"ttl\">s</span> - First in flight",
					image: "assets/images/exploration/CharlesLindbergh-a.jpg",
					imageFit: 'contain',
					text: "Charles Lindbergh wins the Bulova prize for the first trans-Atlantic flight, 1927."
				},
				{
					type: "content",
					image: "assets/images/exploration/LoneEaglewatch.jpg",
					text: "Bulova commemorates this historic feat by introducing the Lone Eagle watch."
				},
				{
					type: "content",
					image: "assets/images/exploration/CharlesLindbergh-letter.jpg",
					text: "Lone Eagle watches were accompanied by a replica letter from Charles Lindbergh.",
					imageFit: 'contain'
				}
			]
		},
		{
			//2
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					image: "assets/images/exploration/watertite.jpg",
					title: "1930<span class=\"ttl\">s</span> - Watertite",
					text: "\"Submerged in a bowl of water- worn in the roughest sea-it will faithfully tell time on time.\""
				}
				,{
					type: "content",
					image: "assets/images/exploration/JohnnyWeismuller.jpg",
					text: "Advertising with Olympic swimmer and Tarzan actor, Johnny Weissmuller.",
					imageFit: 'contain'
				}
			]
		},
		{
			//3
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					image: "assets/images/exploration/commemorate-a.jpg",
					imageFit: 'contain',
					title: "1940<span class=\"ttl\">s</span> - Official Timekeeper For Airlines",
					text: "Bulova, official timepiece for American Airlines."
				},
				{
					type: "content",
					image: "assets/images/exploration/commemorate-b.jpg",
					text: "Bulova, official timepiece for Pan American World Airways, 1954.",
					imageFit: 'contain'
				}
			]
		},
		{
			//4
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					image: "assets/images/exploration/Bulova-LEM-1.jpg",
					imageFit: "contain",
					title: "1960<span class=\"ttl\">s</span> - Bulova Accutron Participated in 46 NASA Space Missions",
					text: "Bulova Lunar Excursion Module Clock."
				},
				{
					type: "content",
					image: "assets/images/exploration/Bulova-LEM-1a.jpg",
					imageFit: "contain",
					text: "Bulova Timing Devices in Space."
				},
				{
					type: "content",
					image: "assets/images/exploration/Bulova-LEM-1b.jpg",
					text: "General Omar N. Bradley, Bulova Chairman from 1958-1974 in the lobby of the Bulova Building in Queens, New York, circa 1960s."
				}
			]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1960<span class=\"ttl\">s</span> - Gemini Mission Clock",
				text: "60 minute timer.",
				image: "assets/images/other/gemini-clock.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1969 - First Man on the Moon",
				text: "Bulova Annual Report.",
				image: "assets/images/exploration/first-moon-report.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1969 - Air Force One",
				text: "Bulova clock on President Lyndon B. Johnson's Air Force One.",
				image: "assets/images/other/air-force-one.jpg"
			}]
		},
		{
			//5
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					title: "1960<span class=\"ttl\">s</span> - Accutron and the CIA",
					image: "assets/images/exploration/A12.jpg",
					text: "The A-12 high altitude, high speed reconnaissance aircraft, Black Hawk."
				},
				{
					type: "content",
					image: "assets/images/exploration/BulovaAccutronAstronaut.jpg",
					text: "Bulova Accutron Astronaut selected by the CIA for Black Hawk missions, 1966."
				}
			]
		},
		{
			//6
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					image: "assets/images/exploration/water-resistant.jpg",
					imageFit: 'contain',
					title: "1960<span class=\"ttl\">s</span> - First to Dive with the Devil",
					text: "Bulova pushes diving limits to 666 feet, earning the nickname \"Devil Diver\", 1966."
				},
				{
					type: "content",
					image: "assets/images/exploration/oceanographer-g.jpg",
					text: "Oceanographer \"G\", 1972."
				},
				{
					type: "content",
					image: "assets/images/exploration/oceanographer-s.jpg",
					text: "Oceanographer \"V\" Snorkel, 1971."
				},
				{
					type: "content",
					imageFit: 'contain',
					image: "assets/images/exploration/shark-ad.jpg",
					text: "Bulova launches daring ad campaign, circa 1970s."
				}
			]
		},
		{
			isInCarousel: false,
			scrollContent: [
				{	
					type: "content",
					image: "assets/images/exploration/Oceanographer-fish.jpg",
					imageFit: 'contain',
					title: "1971 - Oceanographer",
					text: "\"For the man who dares the depths\" print ad."
				}
			]
		},
		{
			isInCarousel: true,
			scrollContent: [
				{	
					type: "content",
					image: "assets/images/exploration/greenland.jpg",
					imageFit: 'contain',
					title: "1970<span class=\"ttl\">s</span> - First in Dependability",
					text: "\"If you get lost in northern Greenland, you die\", Accutron print ad, 1970."
				}
			]
		}
	];

	public static sectionCity = [
		{
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					title: "1870<span class=\"ttl\">s</span> - The Beginning",
					imageFit: "contain",
					text: "Bulova opens in 1875 on Maiden Lane in New York.",
					image: "assets/images/city/Maiden-Lane.jpg"
				}
			]
		},
		{
			isInCarousel: true,
			scrollContent: [
				{
				type: "content",
				imageFit: "contain",
				title: "1920<span class=\"ttl\">s</span> - Early Advertising",
				text: "Clipper Ship print ad, inspired by Maiden Lane's close proxmity to the seaport, 1926.",
				image: "assets/images/city/ClipperShipAd.jpg"
				}
			]
		},
		{
			isInCarousel: true,
			scrollContent: [
			{
				type: "content",
				imageFit: "contain",
				title: "1920<span class=\"ttl\">s</span> - The Bulova Observatory",
				text: "\"Cased and Timed at the Bulova Observatory\", Advertising 1927.",
				image: "assets/images/city/bulova-observatory.jpg"
			}
			]
		},
		{
			//4
			isInCarousel: true,
			scrollContent: [
			{
				type: "content",
				title: "1930<span class=\"ttl\">s</span> - Bulova Employees",
				text: "Bulova Observatory offices, 580 Fifth Avenue.",
				image: "assets/images/city/bulova-employees-1.jpg"
			}
			/*,
			{
				type: "image",
				image: "assets/images/city/bulova-employees-2.jpg"
			},
			{
				type: "image",
				image: "assets/images/city/bulova-employees-3.jpg"
			}*/
			]
		},
		{
			//5
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1950<span class=\"ttl\">s</span> - Bulova in the Boroughs",
				text: "Bulova official timepiece of the Brooklyn Dodgers, Ebbets Field, 1957.",
				image: "assets/images/city/Ebbets-Field.jpg"
			}]
		},
		{
			//6
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1990<span class=\"ttl\">s</span> - New York, NY",
				text: "The New York City Token Watch by Bulova, 1991.",
				image: "assets/images/city/City-Token-Watch.jpg"
			},
			{
				type: "content",
				text: "Watch made from a New York City Subway token, 1991.",
				image: "assets/images/city/City-Token-Watch2.jpg"
			}
			]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				launchAR: true,
				arTextModal: "Use the iPad to experience the very first TV and Radio Advertisements broadcasted LIVE from the Empire State Building.",
				title: "2015  - Back Home Again",
				text: "Bulova moves back to the Empire State Building in 2015. Early Bulova commercials were broadcast from the Empire State Building.",
				image: "assets/images/city/empire.jpg",
			}]
		},
	];

	public static sectionPopCulture = [
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1950<span class=\"ttl\">s</span> - Bulova Brand Ambassadors",
				image: "assets/images/pop-culture/bulova-ad-2.jpg",
				imageFit: "contain",
				text: "Celebrities such as Betty Grable promote Bulova products, 1951."
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "1950<span class=\"ttl\">s</span> - Bulova Conquers Niagara Falls",
				text: "\"Can a watch survive a Niagara Falls test?\", 1956.",
				video: "assets/images/pop-culture/watch-over-niagara.mp4",
				videoBG: "assets/images/pop-culture/watch-over-niagara.mp4"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "1950<span class=\"ttl\">s</span> - Bulova Featured On The Frank Sinatra Show",
				text: "\"It pays to insist on Bulova\", Frank Sinatra Show, 1957.",
				video: "assets/images/pop-culture/frank-sinatra.mp4",
				videoBG: "assets/images/pop-culture/frank-sinatra.mp4"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "video",
				title: "1958 - Miss America",
				text: "Television commercial.",
				video: "assets/images/other/miss-america.mp4",
				videoBG: "assets/images/other/miss-america.mp4"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "video",
				title: "1958 - Bulova Senator",
				text: "Television commercial.",
				video: "assets/images/other/senator-commercial.mp4",
				videoBG: "assets/images/other/senator-commercial.mp4"
			}]
		},

		{
			//4
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1960<span class=\"ttl\">s</span> - Beatles First US Concert",
				text: "Bulova Clock prominently displayed above Beatles' first U.S. concert, 1964.",
				image: "assets/images/pop-culture/Beatles-concert.jpg"
			},
			{
				type: "content",
				text: "The Beatles - Live at Washington Coliseum",
				image: "assets/images/pop-culture/beatles-ar.png",
				launchAR2: true,
				arTextModal: "Use the iPad to experience the first Beatles concert in the U.S. from the Washington Coliseum in Washington DC."
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "video",
				title: "1960<span class=\"ttl\">s</span> - Child Left Behind",
				text: "Television commercial.",
				video: "assets/images/other/child-left-behind.mp4",
				videoBG: "assets/images/other/child-left-behind.mp4"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1970 - Where's Mommy?",
				text: "Print ad.",
				image: "assets/images/other/where-is-mommy.jpg",
				imageFit: "contain"
			}]
		},
		{
			//5
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1970<span class=\"ttl\">s</span> - Equality",
				imageFit: "contain",
				text: "Bulova embraces equality, 1974.",
				image: "assets/images/pop-culture/Equal-Time-Equal-Pay.jpg"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				image: "assets/images/pop-culture/Walter-Cronkite.jpg",
				imageFit: "contain",
				title: "1970<span class=\"ttl\">s</span> - Good news from Bulova, CBS News",
				text: "Walter Cronkite, 1979."
			}]
		},
		/*{
			//7
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "1980<span class=\"ttl\">s</span> - Great Faces Campaign",
				text: "TV ad campaign featuring Muhammad Ali, Morgan Fairchild, Johnny Cash, Bernadette Peters, Roger Daltrey and Christie Brinkley, 1983.",
				video: "assets/images/pop-culture/great-face-campaing.mp4",
				videoBG: "assets/images/pop-culture/great-face-campaing.mp4"
			}]
		},*/
		{
			isInCarousel: false,
			scrollContent: [{
				type: "video",
				title: "1990 - It's America's Time",
				text: "Television commercial.",
				video: "assets/images/other/wayne-eastep.mp4",
				videoBG: "assets/images/other/wayne-eastep.mp4"
			}]
		},
		/*{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "2016 - Official Partner of the GRAMMYS<sup>®</sup> and Latin GRAMMYS<sup>®</sup>",
				text: "The partnership includes a GRAMMY<sup>®</sup>-inspired collection of Bulova timepieces.",
				image: "assets/images/pop-culture/grammy1.jpg"
			}
			]
		},*/
		{
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "2016 - Official Partner of the GRAMMY'S<sup>®</sup> and Latin GRAMMY'S<sup>®</sup>",
				text: "The partnership includes a GRAMMY<sup>®</sup>-inspired collection of Bulova timepieces.",
				video: "assets/images/pop-culture/Bulova-Grammy.mp4",
				videoBG: "assets/images/pop-culture/Bulova-Grammy.mp4"
			}]
		}
	];

	public static sectionInnovation = [
		{
			isInCarousel: true,
			scrollContent: [{
				type: "audio",
				buttonText: "Listen",
				title: "1920<span class=\"ttl\">s</span> - First In Advertising",
				text: "Bulova broadcasts world's first radio commercial in 1926.",
				video: "assets/images/innovation/broadcast-audio.mp4",
				videoBG: "assets/images/innovation/broadcast-audio.mp4",
				image: "assets/images/innovation/broadcast-audio-bg.png",
				imageFit: "contain"
			}]
		},
		{
			//2
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "1940<span class=\"ttl\">s</span> - World's First Television Commercial",
				text: "\"America runs on Bulova Time\" airs July 1, 1941 before a Brooklyn Dodgers - Philadelphia Phillies baseball game.",
				video: "assets/images/innovation/first-tv-commercial.mp4",
				videoBG: "assets/images/innovation/first-tv-commercial.mp4"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "video",
				title: "Bulova Supports our veterans, 1945",
				text: "Joseph Bulova Watchmaking School for veterans.",
				video: "assets/images/other/newreal-1945.mp4",
				videoBG: "assets/images/other/newreal-1945.mp4"
			}]
		},
		{
			//3
			isInCarousel: true,
			scrollContent: [
				{
					type: "content",
					title: "1950<span class=\"ttl\">s</span> - Bulova Invents The Phototimer",
					text: "Photo finish at Madison Square Garden captuterd by Bulova's Phototimer, 1951.",
					image: "assets/images/innovation/phototimer-a.jpg",
					imageFit: "contain"
				}
			]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1950<span class=\"ttl\">s</span> - Jackie Gleason Show",
				text: "According to Nielson, in 1955 Americans saw more advertising for Bulova than any products, in any industry.",
				image: "assets/images/other/red-ad.jpg",
				imageFit: "contain"
			}]
		},
		{
			//4
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1960<span class=\"ttl\">s</span> - Bulova Introduces the Accutron Movement",
				text: "The first Electronic watch.",
				//image: "assets/images/innovation/accutron-watch.jpg",
				image: "assets/images/innovation/accutron-0.jpg"
			},
			/*{
				type: "content",
				//title: "1960<span class=\"ttl\">s</span> - Bulova Introduces the Accutron Movement",
				//text: "The first Electronic watch.",
				image: "assets/images/innovation/accutron-2.jpg",
				imageFit: "contain"
			},*/
			/*{
				type: "content",
				//title: "1960<span class=\"ttl\">s</span> - Bulova Introduces the Accutron Movement",
				//text: "The first Electronic watch.",
				image: "assets/images/innovation/accutron-3.jpg",
				imageFit: "contain"
			}*/]
		},
		{
			//5
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "2010 - Precisionist",
				text: "The world’s most accurate watch with a continuously sweeping second hand.",
				video: "assets/images/innovation/Precisionist.mp4",
				videoBG: "assets/images/innovation/Precisionist.mp4"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1963 - 65 Teens for the Prom",
				text: "Print ad.",
				image: "assets/images/other/65-teens.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1963 - Mailmen",
				text: "Print ad.",
				image: "assets/images/other/mailmen.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1963 - Car Buffs",
				text: "Print ad.",
				image: "assets/images/other/car-buff.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1964 - Firefighter",
				text: "Print ad.",
				image: "assets/images/other/firefighter.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1964 - Equestrians",
				text: "Print ad.",
				image: "assets/images/other/equestrians.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1964 - Beauties on the Beach",
				text: "Print ad.",
				image: "assets/images/other/beauty-beach.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1964 - 9 Months",
				text: "Print ad.",
				image: "assets/images/other/nine-months-ad.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1970 - Parking Meter",
				text: "Print ad.",
				image: "assets/images/other/parking-meter.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: false,
			scrollContent: [{
				type: "content",
				title: "1988 - At the Ballpark",
				text: "Print ad.",
				image: "assets/images/other/olympics.jpg",
				imageFit: "contain"
			}]
		},
		{
			//5
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "2016 - CURV",
				text: "Bulova introduces the World's First Curved Chronograph movement.",
				video: "assets/images/innovation/curv-video.mp4",
				videoBG: "assets/images/innovation/curv-video.mp4"
			}
			/*{
				type: "image",
				image: "assets/images/innovation/curv1.jpg"
			},
			{
				type: "image",
				image: "assets/images/innovation/curv2.jpg"
			}*/
			]
		},
		{
			//6
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "2019 - Accutron",
				text: "First Electrostatic concept movement is introduced.",
				video: "assets/images/innovation/bulova-accutron.mp4",
				videoBG: "assets/images/innovation/bulova-accutron.mp4"
			}]
		}
	];

	public static sectionOther = [
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "Bulova's 46 Nasa Space Missions",
				text: "1969 Bulova Annual Report",
				image: "assets/images/other/bulova-report.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "Air Force One",
				text: "Bulova clock on President Lyndon B. Johnson's Air Force One, 1969.",
				image: "assets/images/other/air-force-one.jpg"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "Laguardia Airport",
				text: "Bulova Clock, 1945.",
				image: "assets/images/other/laguardia.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "Regatta",
				text: "Watch ad, 1963.",
				image: "assets/images/other/regatta.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "Sea King",
				text: "1967.",
				image: "assets/images/other/sea-king.jpg"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "Accutron Marine Navigator",
				text: "1969.",
				image: "assets/images/other/accutron-marine-navigator.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "mad Men Episode",
				//text: "Bulova Senator.",
				video: "assets/images/other/mad-men.mp4",
				videoBG: "assets/images/other/mad-men.mp4"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "Zoolander 2001",
				//text: "Bulova Senator.",
				video: "assets/images/other/zoolander.mp4",
				videoBG: "assets/images/other/zoolander.mp4"
			}]
		},
		
		
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1965",
				text: "Bulova Phototimer aids officials in close decisions, 1965.",
				image: "assets/images/other/pistol-set.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1960<span class=\"ttl\">s</span> - Innovative Advertising",
				text: "\"This Watch Could Kill You\" print ad, 1969.",
				image: "assets/images/other/watch-kill-add.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "content",
				title: "1970<span class=\"ttl\">s</span> - Taking Watches To New Depths",
				text: "Oceanographer print ad, 1971.",
				image: "assets/images/other/oceanographer.jpg",
				imageFit: "contain"
			}]
		},
		{
			isInCarousel: true,
			scrollContent: [{
				type: "video",
				title: "1940<span class=\"ttl\">s</span> - Official Timekeeper For Airlines",
				text: "Bulova commemorates the company's 130th anniversary with the 2005 Ambassador watch.",
				video: "assets/images/other/commemorate.mp4",
				videoBG: "assets/images/other/commemorate.mp4"
			}]
		}
	];




}